import React, { Component } from "react";
import { CustomTextField } from "./TextField";

class Comments extends Component {
  static defaultProps = {
    value: "",
    errorText: "",
    onChange: () => {},
    onBlur: () => {}
  };

  constructor(props) {
    super(props);
    this.state = { textLength: 0 };
  }

  handleChange = e => {
    const { value } = e.target;
    if (value.length > 200) return;
    this.setState({ textLength: value.length });
    this.props.onChange(this.props.fieldKey, value);
  };

  renderTextLengthReminder = () => {
    if (this.state.textLength === 0) return null;
    return (
      <span style={{ float: "right", color: "#ed135d" }}>
        {this.state.textLength} / 200
      </span>
    );
  };

  render() {
    return (
      <div>
        <CustomTextField
          multiLine
          rowsMax={4}
          floatingLabelText="Comments (optional)"
          value={this.props.value}
          onChange={this.handleChange}
        />
        {this.renderTextLengthReminder()}
      </div>
    );
  }
}

export { Comments };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/FormFields/Comments.js